import { SKELETON_KEY, SKELETON_KEY_NUMBER } from './skeletonFactory';

export function skeletonAnalyticsReport() {
  return {
    id: SKELETON_KEY,
    name: SKELETON_KEY,
    reportType: SKELETON_KEY,
    month: SKELETON_KEY_NUMBER,
    year: SKELETON_KEY_NUMBER,
    reportFileUrl: SKELETON_KEY,
    reportFileName: SKELETON_KEY,
    reportFileMimeType: SKELETON_KEY
  };
}
